import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './css/GroupedByDateLoader.css';

function GroupedByDateLoader() {
  return (
    <div className="offer_details_selected">
      <div className="hd_room_container">
        <div className="hd_day_room_w">
          <div className="hd_room_type">
            <Skeleton width="150px" height="20px" />
          </div>

          <div className="tb_night_w tb_loader_item">
            <div className="tb_mights_title_w">
              <div className="tb_night_title hd_title_load">
                <Skeleton width="67px" height="20px" />
              </div>
              <div className="gr_text_14">
                <Skeleton width="90px" height="15px" />
              </div>
            </div>
            <div className="tb_meal_item tb_meal_item_loader">
              <div className="bm_text_12 mb_12">
                <Skeleton width="100px" height="12px" />
              </div>
              <div className="tb_tour_meal_price_w">
                <div className="tb_tour_button">
                  <div>
                    <Skeleton width="80px" height="20px" />
                  </div>
                </div>
                <div className="br_text_14 mb_8">
                  <Skeleton width="120px" height="16px" />
                </div>
                <Skeleton width="150px" height="18px" />
              </div>
            </div>
          </div>
          <div className="tb_night_w tb_loader_item">
            <div className="tb_mights_title_w">
              <div className="tb_night_title hd_title_load">
                <Skeleton width="67px" height="20px" />
              </div>
              <div className="gr_text_14">
                <Skeleton width="90px" height="15px" />
              </div>
            </div>
            <div className="tb_meal_item tb_meal_item_loader">
              <div className="bm_text_12 mb_12">
                <Skeleton width="100px" height="12px" />
              </div>
              <div className="tb_tour_meal_price_w">
                <div className="tb_tour_button">
                  <div>
                    <Skeleton width="80px" height="20px" />
                  </div>
                </div>
                <div className="br_text_14 mb_8">
                  <Skeleton width="120px" height="16px" />
                </div>
                <Skeleton width="150px" height="18px" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hd_room_container">
        <div className="hd_day_room_w">
          <div className="hd_room_type">
            <Skeleton width="150px" height="20px" />
          </div>

          <div className="tb_night_w tb_loader_item">
            <div className="tb_mights_title_w">
              <div className="tb_night_title hd_title_load">
                <Skeleton width="67px" height="20px" />
              </div>
              <div className="gr_text_14">
                <Skeleton width="90px" height="15px" />
              </div>
            </div>
            <div className="tb_meal_item tb_meal_item_loader">
              <div className="bm_text_12 mb_12">
                <Skeleton width="100px" height="12px" />
              </div>
              <div className="tb_tour_meal_price_w">
                <div className="tb_tour_button">
                  <div>
                    <Skeleton width="80px" height="20px" />
                  </div>
                </div>
                <div className="br_text_14 mb_8">
                  <Skeleton width="120px" height="16px" />
                </div>
                <Skeleton width="150px" height="18px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupedByDateLoader;
